import { ExerciseInterface } from "../../../interfaces/examInterfaces";

export const MANIPULATE_EXERCISES_TYPES = {
  IMAGE_ZOOM: "imageZoom",
  INDEX_NEW_EXERCISES: "indexNewExercises",
  NEW_EXERCISES: "newExercises",
};

export const MANIPULATE_EXERCISES_INITIAL_STATE: ManipulateExercisesState = {
  imageZoom: "",
  indexNewExercises: 0,
  newExercises: [],
};

export interface ManipulateExercisesState {
  imageZoom: string;
  indexNewExercises: number;
  newExercises: ExerciseInterface[];
}

export interface Action {
  type: string;
  payload: any;
}

export const manipulateExercisesReducer = (
  state = MANIPULATE_EXERCISES_INITIAL_STATE,
  action: Action
): ManipulateExercisesState => {
  switch (action.type) {
    case MANIPULATE_EXERCISES_TYPES.IMAGE_ZOOM:
      return { ...state, imageZoom: action.payload };

    case MANIPULATE_EXERCISES_TYPES.INDEX_NEW_EXERCISES:
      return { ...state, indexNewExercises: action.payload };

    case MANIPULATE_EXERCISES_TYPES.NEW_EXERCISES:
      return { ...state, newExercises: action.payload };

    default:
      return state;
  }
};
